// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"5ae30f2c","137":"a313cc93","141":"299bfa97","196":"f8489cb7","256":"b1875cb5","320":"ce355517","335":"c0296c5b","350":"60c5360e","361":"ee5be63c","453":"58a7a83b","464":"1a3dd617","560":"1acfc352","840":"cb2e7be5","861":"38659392","948":"268749ab"}[chunkId] + ".chunk.js";
};